enum VerificationType {
  'email' = 'email',
  'file' = 'file',
}

export default VerificationType;
